import { render } from "./schoolRight.vue?vue&type=template&id=f75f6682&scoped=true"
import script from "./schoolRight.vue?vue&type=script&lang=js"
export * from "./schoolRight.vue?vue&type=script&lang=js"

import "./schoolRight.vue?vue&type=style&index=0&id=f75f6682&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f75f6682"]])

export default __exports__